<template>
  <v-avatar class="avatar-icon" color="#f1f1f1">
    <v-icon color="primary">{{ icon }}</v-icon>
  </v-avatar>
</template>

<script>
export default {
  name: "AvatarIcon",

  props: ["icon"],
};
</script>

<style lang="scss" scoped></style>
